import * as React from 'react';
import { Layout as AntLayout, Menu } from 'antd';

import AccountHeader from '../common/components/AccountHeader';
import '../App.less';
import './welcome/Welcome.less';
import Success from '../assets/Success';

const FinishPage: React.FC = () => {
  return (
    <AntLayout style={{ height: '100vh' }}>
      <AccountHeader />
      <AntLayout className="finishpage">
        <Success />
        <h1 className="mt-16">Congratulations!</h1>
      </AntLayout>
    </AntLayout>
  );
};
export default FinishPage;
